module.exports = __webpack_public_path__ + "img/29.8570cece.jpg";